import axios from "axios";

const SSOService = axios.create({
  baseURL:
    // "http://sso.simplifycv.com/", // Development
    // "https://auth.simplifymycareer.com/", // Staging & Development
    "https://auth.hire3x.com/" // Production
});

const notificationAuth = axios.create({
	// baseURL: "https://notification.simplifycv.com/", // Dev Gateway
	// baseURL: "https://notification.simplifymycareer.com/", // Staging
  baseURL: "https://notification.hire3x.com/", // Staging

});

export { SSOService, notificationAuth };
